import { render, staticRenderFns } from "./confirmacionPrecio.vue?vue&type=template&id=adee194c"
import script from "./confirmacionPrecio.vue?vue&type=script&lang=js"
export * from "./confirmacionPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports